module.exports = __webpack_public_path__ + "img/calibrated.64896b00.jpg";